import { Select } from "antd";
const { Option } = Select;

export const getDropdownValuesAsSelectOptions = (entries) => {
  const opts = [];
  entries.forEach((entry) => {
    opts.push(
      <Option key={entry._id} value={entry._id}>
        {entry.label}
      </Option>
    );
  });
  return opts;
};

export const getError = ({ errors, name }) => {
  //console.log({ errors, name });
  if (name.indexOf(".") === -1) {
    return errors[name];
  } else {
    const nameArr = name.split(".");
    let errorsToPick = { ...errors };
    for (const key of nameArr) {
      if (errorsToPick) {
        errorsToPick = errorsToPick[key];
      }
    }
    return errorsToPick;
  }
};

export const getCountryOptions = (countries) => {
  const opts = [];
  if (countries?.length) {
    countries.forEach((country) => {
      opts.push(
        <Option key={country._id} value={country._id}>
          {country.name}
        </Option>
      );
    });
  }
  return opts;
};

export const getStateOptions = (states) => {
  const opts = [];

  states.forEach((state) => {
    opts.push(
      <Option key={state._id} value={state._id}>
        {state.name}
      </Option>
    );
  });

  return opts;
};

export const getCityOptions = (cities) => {
  let opts = [];

  cities.forEach((city) => {
    opts.push(
      <Option key={city._id} value={city._id}>
        {city.name}
      </Option>
    );
  });
  return opts;
};
